import { ActorProfilePreviewFragmentFragment } from '@lopo-tech/lopo-api'
import React from 'react'
import NavigationItem from 'src/components/navigation_item/navigation_item'
import { CLASS_PREFIX } from 'src/constants'
import { UrlUtils } from 'src/utils/url/url'

import { useHistory } from 'react-router-dom'
import './project_participant.scss'

const cls = CLASS_PREFIX + 'project-participant'

type Props = {
  participant: ActorProfilePreviewFragmentFragment;
};

export const ProjectParticipant: React.FC<Props> = ({ participant }) => {
  const history = useHistory()
  const profileLink = participant.canShow.value
    ? UrlUtils.getProfileFrontendPath(participant.slug, participant.__typename)
    : undefined

  return (
    <NavigationItem
      onClick={() => {
        if (profileLink) history.push(profileLink)
      }}
      url={profileLink}
      target="_self"
    >
      <div className={cls}>
        <img
          className={`${cls}__avatar`}
          src={participant.avatar.previewUrl}
          alt=""
          loading="lazy"
        />
        <div className={`${cls}__name`}>{participant.name}</div>
      </div>
    </NavigationItem>
  )
}
